import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import {useRef, useState} from 'react'
import useSubmitErrorFeedbackMutation from '../mutations/useSubmitErrorFeedbackMutation'
import {LocalStorageKey} from '../types/constEnums'
import {Button} from '../ui/Button/Button'
import {Dialog} from '../ui/Dialog/Dialog'
import {DialogContent} from '../ui/Dialog/DialogContent'
import {DialogTitle} from '../ui/Dialog/DialogTitle'
import BasicTextArea from './InputField/BasicTextArea'








const parseFormConfig = () => {
  const rawUrl = window.__ACTION__.GOOGLE_ERROR_FORM_URL
  if (!rawUrl) return null
  try {
    const parsed = new URL(rawUrl)
    const emailField = parsed.searchParams.get('_email')
    const subjectField = parsed.searchParams.get('_subject')
    const contentField = parsed.searchParams.get('_content')
    const eventIdField = parsed.searchParams.get('_eventId')
    if (!emailField || !subjectField || !contentField || !eventIdField) return null
    parsed.searchParams.delete('_email')
    parsed.searchParams.delete('_subject')
    parsed.searchParams.delete('_content')
    parsed.searchParams.delete('_eventId')
    return {url: parsed.toString(), emailField, subjectField, contentField, eventIdField}
  } catch (e2) {
    return null
  }
}

const formConfig = parseFormConfig()

// Dual-write during the CRM decoupling transition: Postgres is the system of
// record; the Google Form post is best-effort until ops confirms the PG path.
const postToGoogleForm = (email, error, text, eventId) => {
  if (!formConfig) return
  const {url, emailField, subjectField, contentField, eventIdField} = formConfig
  const body = new URLSearchParams({
    [emailField]: email || 'errors@parabol.co',
    [subjectField]: error.message,
    [contentField]: text,
    [eventIdField]: eventId
  })
  fetch(url, {method: 'POST', mode: 'no-cors', body})
}

const ReportErrorFeedback = (props) => {
  const {isOpen, onClose, error, eventId} = props
  const [text, setText] = useState('')
  const [submitError, setSubmitError] = useState()
  const [execute, submitting] = useSubmitErrorFeedbackMutation()
  const formPostedRef = useRef(false)
  const onChange = (e) => {
    setText(e.target.value)
    setSubmitError(undefined)
  }

  const onSubmit = () => {
    if (!text.trim() || submitting) return
    const email = window.localStorage.getItem(LocalStorageKey.EMAIL)
    if (!formPostedRef.current) {
      formPostedRef.current = true
      postToGoogleForm(email, error, text, eventId)
    }
    execute({
      variables: {
        errorMessage: error.message,
        content: text,
        eventId,
        email
      },
      onCompleted: (_res, errors) => {
        if (_optionalChain([errors, 'optionalAccess', _ => _.length])) {
          setSubmitError(errors[0].message)
          return
        }
        setText('')
        formPostedRef.current = false
        onClose()
      },
      onError: (err) => setSubmitError(err.message)
    })
  }

  return (
    _jsx(Dialog, { isOpen: isOpen, onClose: onClose, children: 
      _jsxs(DialogContent, { children: [
        _jsx(DialogTitle, { className: "mb-4", children: "Report Error" })
        , _jsx('div', { className: "mb-4 pl-0 text-fg-primary text-sm"   , children: "What were you doing when the error happened?"

        })
        , _jsx(BasicTextArea, {
          autoFocus: true,
          name: "errorReport",
          onChange: onChange,
          value: text,
          error: submitError,}
        )
        , _jsx('div', { className: "mt-6 flex justify-end"  , children: 
          _jsx(Button, {
            variant: "primary",
            onClick: onSubmit,
            disabled: text.trim().length === 0 || submitting,
            size: "md",
 children: 
            'Submit Report'
          })
        })
      ]})
    })
  )
}

export default ReportErrorFeedback
